const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class DevelopmentOfMarkets extends Event {
    constructor(){
        super(
            Age.AgeA,
            EventNames.DevelopmentOfMarkets,
            "Each civilization gains 2 food or 2 resources.",
            {}
        )
    }
}

module.exports = DevelopmentOfMarkets;